import React, { Component } from 'react';
import PropTypes from 'prop-types';
import env from 'lib/env';
import moment from 'moment-timezone';
import { get } from 'lodash';
import VisibilitySensor from 'react-visibility-sensor';
import { FormattedMessage } from 'react-intl';

import { pageProps } from 'lib/analytics/page-properties';
import { BUTTON_IMPRESSION, BUTTON_CLICK } from 'lib/analytics/events';
import * as AppContext from 'lib/app-context';

import Booking from 'models/booking';
import { Location } from 'models/locations';

const { PW_URL } = env();
const OBJECT_NAME = 'Extend';

const propTypes = {
  app: PropTypes.string.isRequired,
  appContext: PropTypes.string.isRequired,
  booking: PropTypes.instanceOf(Booking).isRequired,
  location: PropTypes.instanceOf(Location).isRequired,
  trackEvent: PropTypes.func.isRequired,
};

class ExtendPassButton extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
  }

  onClick() {
    const { app, booking, trackEvent } = this.props;
    const pageProperties = pageProps({ app });
    trackEvent({
      ...BUTTON_CLICK,
      ...pageProperties,
      name: OBJECT_NAME,
    });
    window.open(`${PW_URL}/instant-park/checkout/?booking-id=${booking.id}&booking-authorization-code=${booking.authorizationCode}`, '_top');
  }

  onVisibilityChange(isVisible) {
    const { app, trackEvent } = this.props;
    if (isVisible) {
      const pageProperties = pageProps({ app });
      trackEvent({
        ...BUTTON_IMPRESSION,
        ...pageProperties,
        name: OBJECT_NAME,
      });
    }
  }

  shouldRenderButton() {
    const { appContext, booking, location } = this.props;

    return (
      location.supportsBookingExtension &&
      booking.isActive &&
      moment().isBetween(booking.startTime, booking.endTime) &&
      (get(booking, 'partner.isParkWhiz') || get(booking, 'partner.isBestParking')) &&
      appContext === AppContext.MOBILE
    );
  }

  render() {
    if (!this.shouldRenderButton()) { return null; }

    return (
      <VisibilitySensor onChange={this.onVisibilityChange} partialVisibility>
        <div className="extend-pass-button">
          <span className="clock-icon-extend" />
          <a className="extend-pass-text" onClick={this.onClick}>
            <FormattedMessage id="parking-pass.extend-pass" defaultMessage="Extend End Time" />
          </a>
        </div>
      </VisibilitySensor>
    );
  }
}

ExtendPassButton.propTypes = propTypes;

export default ExtendPassButton;
